import React, { useState } from "react";
import "./product2.css";

const Frame1 = () => {
  const [isImageOpen1, setIsImageOpen1] = useState(false);
  const [isImageOpen2, setIsImageOpen2] = useState(false);
  const [isImageOpen3, setIsImageOpen3] = useState(false);
  const [isImageOpen4, setIsImageOpen4] = useState(false);
  const [isImageOpen5, setIsImageOpen5] = useState(false);
  const [isImageOpen6, setIsImageOpen6] = useState(false);
  const [isImageOpen7, setIsImageOpen7] = useState(false);

  const closeImage = (imageNumber) => {
    switch (imageNumber) {
      case 1:
        setIsImageOpen1(false);
        break;
      case 2:
        setIsImageOpen2(false);
        break;
      case 3:
        setIsImageOpen3(false);
        break;
      case 4:
        setIsImageOpen4(false);
        break;
      case 5:
        setIsImageOpen5(false);
        break;
      case 6:
        setIsImageOpen6(false);
        break;
      case 7:
        setIsImageOpen7(false);
        break;
      default:
        break;
    }
  };

  const handleImageClick = (event, imageNumber) => {
    event.preventDefault();
    switch (imageNumber) {
      case 1:
        setIsImageOpen1(true);
        break;
      case 2:
        setIsImageOpen2(true);
        break;
      case 3:
        setIsImageOpen3(true);
        break;
      case 4:
        setIsImageOpen4(true);
        break;
      case 5:
        setIsImageOpen5(true);
        break;
      case 6:
        setIsImageOpen6(true);
        break;
      case 7:
        setIsImageOpen7(true);
        break;
      default:
        break;
    }
  };

  return (
    <div className="rectangle-root">
      <div className="frame-item4" />
      <div className="frame-item" />
      <div className="frame-inner" />

      <div className="rectangle-group">
        <div className="rectangle-div" />
        <img className="logo-1-icon1" alt="" src="/logo.png" />
        <b className="our-products1" ><a href="#ourproducts">OUR PRODUCTS</a></b>
      </div>
      <div className="rectangle-icon" />


      <div className="view-demo3"><a href="https://sleet-yielding-manatee.glitch.me">VIEW</a>
      </div>




      <div className="view-demo1">
        <a href="https://purple-evanescent-kosmoceratops.glitch.me">VIEW</a>
      </div>



      <div className="view-demo2" >
        <a href="https://early-lemon-forest.glitch.me">VIEW</a>
      </div>

      <div className="view-demo" >
        <a href="https://legend-adaptive-quiver.glitch.me">VIEW</a>
      </div>

      {/* 3https://legend-adaptive-quiver.glitch.me
      4https://early-lemon-forest.glitch.me
      1https://purple-evanescent-kosmoceratops.glitch.me
      2https://sleet-yielding-manatee.glitch.me */}

      <div className="our-products"> WORKS OF OUR TEAM</div>

      <div className="logo-1-icon2">Forget the limitations of flat screens and static images. Enter the world of WebXR, where immersive 3D experiences take education and product presentations to a whole new level. Imagine students exploring the human body in stunning detail, or potential customers virtually stepping into their dream car. With WebXR and interactive 3D models, the possibilities are endless.</div>
      <div className="logo-2-icon">WebXR virtual tours take the traditional virtual tour experience to a whole new level of immersion and interactivity. Imagine stepping into a 3D environment, not just watching it on a screen. Explore any location, from historical landmarks to art galleries, even outer space, all within the comfort of your own surroundings.</div>
      <div className="logo-3-icon">Imagine stepping into your dream home before it's even built. Or touring a Interior from your living room. WebXR for architecture makes this a reality, transforming static blueprints into immersive, interactive experiences that redefine how we envision and inhabit spaces.</div>
      <div className="logo-4-icon">WebXR virtual tours take the traditional virtual tour experience to a whole new level of immersion and interactivity. </div>


      <div className="built-on-augmented">
        <a className="experience1" href="pro1.png" onClick={(e) => handleImageClick(e, 1)}>
          EXPERIENCE
        </a>
        {isImageOpen1 && (
          <div className="image-overlay">
            <button className="close-button" onClick={() => closeImage(1)}>
              Close
            </button>
            <img src="pro1.png" alt="Product 1" />
          </div>
        )}
      </div>

      <div className="built-on-augmented1">
        <a className="experience2" href="pro2.png" onClick={(e) => handleImageClick(e, 2)}>
          EXPERIENCE
        </a>
        {isImageOpen2 && (
          <div className="image-overlay1">
            <button className="close-button1" onClick={() => closeImage(2)}>
              Close
            </button>
            <img src="pro2.png" alt="Product 2" />
          </div>
        )}
      </div>

      <div className="built-on-augmented2">
        <a className="experience3" href="pro3.png" onClick={(e) => handleImageClick(e, 3)}>
          EXPERIENCE
        </a>
        {isImageOpen3 && (
          <div className="image-overlay2">
            <button className="close-button2" onClick={() => closeImage(3)}>
              Close
            </button>
            <img src="pro3.png" alt="Product 3" />
          </div>
        )}
      </div>

      <div className="built-on-augmented3">
        <a className="experience4" href="pro4.png" onClick={(e) => handleImageClick(e, 4)}>
          EXPERIENCE
        </a>
        {isImageOpen4 && (
          <div className="image-overlay3">
            <button className="close-button3" onClick={() => closeImage(4)}>
              Close
            </button>
            <img src="pro4.png" alt="Product 4" />
          </div>
        )}
      </div>

      <div className="built-on-augmented11">
        <a className="experience5" href="Kalvi.png" onClick={(e) => handleImageClick(e, 5)}>
          EXPERIENCE
        </a>
        <p className="pexperi"></p>
        <a className="experience" target="_Blank" href="EdXARBrochure.pdf">
          Brochure
        </a>
        {isImageOpen5 && (
          <div className="image-overlay1">
            <button className="close-button1" onClick={() => closeImage(5)}>
              Close
            </button>
            <img className="built-on-augmentedimg11" src="ed_screenshot.png" alt="Product 4" />
          </div>
        )}
      </div>

      <div className="built-on-augmented22">
        <a className="experience6" href="pro3.png" onClick={(e) => handleImageClick(e, 6)}>
          EXPERIENCE
        </a>
        <p className="pexperi"></p>
        <a className="experience" target="_blank" href="JevelAR_brochure.pdf" >
          Brochure
        </a>
        {isImageOpen6 && (
          <div className="image-overlay2">
            <button className="close-button2" onClick={() => closeImage(6)}>
              Close
            </button>
            <img className="built-on-augmentedimg22" src="ar_screenshot.png" alt="Product 5" />
          </div>
        )}
      </div>

      <div className="built-on-augmented33">
        <a className="experience7" href="pro4.png" onClick={(e) => handleImageClick(e, 7)}>
          EXPERIENCE
        </a>
        <p className="pexperi"></p>
        {/* <a className="experience" target="_blank" href="JevelAR_brochure.pdf" >
          Brochure
        </a> */}
        {isImageOpen7 && (
          <div className="image-overlay3">
            <button className="close-button3" onClick={() => closeImage(7)}>
              Close
            </button>
            <img src="sp_screenshot.png" alt="Product 6" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Frame1;